var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4932 32H0L8.83562 0H21.2055L16.4932 32ZM38.2877 32H21.7945L30.6301 0H43L38.2877 32Z",
    fill: "#337D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteSymbol);
export default __webpack_public_path__ + "static/media/Quote-symbol.1cb7acd7da7c2000ad0b4ffa33dc4a9f.svg";
export { ForwardRef as ReactComponent };